import { render, staticRenderFns } from "./how-we-do.vue?vue&type=template&id=6740fe30&scoped=true"
import script from "./how-we-do.vue?vue&type=script&lang=js"
export * from "./how-we-do.vue?vue&type=script&lang=js"
import style0 from "./how-we-do.vue?vue&type=style&index=0&id=6740fe30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740fe30",
  null
  
)

export default component.exports